import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import { communityLines } from './api';

/**
 * Post as a managed account: a new discussion or a reply. attrs: state (accounts, selected).
 * The chosen account is sent with the request and checked on the server; choosing it here grants nothing.
 */
export default class PostTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.kind = 'discussion';
    this.reset();
    this.sending = false;
    this.last = null;
  }
  reset() {
    this.form = {
      title: '',
      content: '',
      tags: [],
      discussion: '',
      replyTo: ''
    };
  }
  tags() {
    const all = (app.store.all('tags') || []).filter(t => !(t.isHidden && t.isHidden()));
    const byPos = (a, b) => (a.position() ?? 999) - (b.position() ?? 999) || a.name().localeCompare(b.name());
    const primary = all.filter(t => t.position() !== null && !t.parent()).sort(byPos);
    const childrenOf = t => all.filter(c => c.parent() === t).sort(byPos);
    const secondary = all.filter(t => t.position() === null).sort((a, b) => a.name().localeCompare(b.name()));
    return {
      primary,
      childrenOf,
      secondary
    };
  }
  view() {
    const s = this.attrs.state;
    const active = (s.accounts || []).filter(a => a.status === 'active');
    const current = active.find(a => a.userId === s.selected);
    return m("div", {
      className: "VEC-post"
    }, m("div", {
      className: "VEC-card VEC-as"
    }, m("label", {
      className: "VEC-field"
    }, m("span", null, "Posting as"), m("select", {
      className: "FormControl",
      value: s.selected || '',
      onchange: e => s.selected = parseInt(e.target.value, 10) || null
    }, m("option", {
      value: ""
    }, "Choose an account\u2026"), active.map(a => m("option", {
      value: a.userId
    }, a.displayName, " (@", a.username, ")")))), current ? m("p", {
      className: "VEC-help"
    }, "Posts appear as ", m("strong", null, current.displayName), ", with the Voucha Team badge.", ' ', communityLines(current.community).slice(0, 2).join(' · ')) : m("p", {
      className: "VEC-help"
    }, "Only active accounts are listed. Resume a paused account in Accounts to post as it.")), m("div", {
      className: "VEC-kind"
    }, m(Button, {
      className: 'Button' + (this.kind === 'discussion' ? ' Button--primary' : ''),
      icon: "fas fa-plus",
      onclick: () => this.kind = 'discussion'
    }, "New discussion"), m(Button, {
      className: 'Button' + (this.kind === 'reply' ? ' Button--primary' : ''),
      icon: "fas fa-reply",
      onclick: () => this.kind = 'reply'
    }, "Reply")), m("form", {
      className: "VEC-card",
      onsubmit: e => {
        e.preventDefault();
        this.publish(current);
      }
    }, this.kind === 'discussion' ? this.discussionFields() : this.replyFields(), m("label", {
      className: "VEC-field is-wide"
    }, m("span", null, this.kind === 'discussion' ? 'Opening post' : 'Reply'), m("textarea", {
      className: "FormControl VEC-content",
      rows: "9",
      value: this.form.content,
      oninput: e => this.form.content = e.target.value,
      placeholder: "Markdown works as in the composer"
    })), m("div", {
      className: "VEC-actions"
    }, m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.sending,
      disabled: !current
    }, this.kind === 'discussion' ? 'Publish discussion' : 'Publish reply'), this.last ? m("a", {
      className: "VEC-last",
      href: this.last.url,
      target: "_blank",
      rel: "noopener"
    }, m("i", {
      className: "fas fa-check"
    }), " Published: open it") : null)));
  }
  discussionFields() {
    const {
      primary,
      childrenOf,
      secondary
    } = this.tags();
    const chip = t => {
      const on = this.form.tags.includes(t.id());
      return m("button", {
        type: "button",
        className: 'VEC-tag' + (on ? ' is-on' : ''),
        style: on && t.color() ? {
          background: t.color(),
          borderColor: t.color()
        } : null,
        onclick: () => this.form.tags = on ? this.form.tags.filter(x => x !== t.id()) : [...this.form.tags, t.id()]
      }, t.name());
    };
    return [m("label", {
      className: "VEC-field is-wide"
    }, m("span", null, "Title"), m("input", {
      className: "FormControl",
      value: this.form.title,
      maxlength: "80",
      oninput: e => this.form.title = e.target.value
    })), m("div", {
      className: "VEC-field is-wide"
    }, m("span", null, "Tags"), m("div", {
      className: "VEC-tags"
    }, primary.map(t => [chip(t), ...childrenOf(t).map(chip)])), secondary.length ? m("div", {
      className: "VEC-tags is-secondary"
    }, secondary.map(chip)) : null, m("small", {
      className: "VEC-muted"
    }, "Pick tags the same way as in the composer (a main tag, plus any sub-tags)."))];
  }
  replyFields() {
    return [m("label", {
      className: "VEC-field is-wide"
    }, m("span", null, "Discussion"), m("input", {
      className: "FormControl",
      value: this.form.discussion,
      placeholder: "Paste the discussion link, e.g. https://thevoucha.com/d/123-title",
      oninput: e => this.form.discussion = e.target.value
    })), m("label", {
      className: "VEC-field is-narrow"
    }, m("span", null, "Reply to post #"), m("input", {
      className: "FormControl",
      type: "number",
      min: "1",
      value: this.form.replyTo,
      placeholder: "optional",
      oninput: e => this.form.replyTo = e.target.value
    }))];
  }
  publish(account) {
    if (!account) return;
    this.sending = true;
    const body = {
      account: account.userId,
      kind: this.kind,
      content: this.form.content
    };
    if (this.kind === 'discussion') Object.assign(body, {
      title: this.form.title,
      tags: this.form.tags
    });else Object.assign(body, {
      discussion: this.form.discussion,
      replyTo: this.form.replyTo || null
    });
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/voucha-engagement/publish',
      body
    }).then(r => {
      this.last = {
        url: app.forum.attribute('baseUrl') + r.url
      };
      app.alerts.show({
        type: 'success'
      }, 'Published as ' + account.displayName + '.');
      const keepDiscussion = this.kind === 'reply' ? this.form.discussion : '';
      this.reset();
      this.form.discussion = keepDiscussion; // handy for several replies in the same thread
      this.attrs.state.load();
    }).catch(() => {}).finally(() => {
      this.sending = false;
      m.redraw();
    });
  }
}